import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: jq-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .jq-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .jq-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .jq-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .jq-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .jq-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .jq-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .jq-hero__title.jq-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .jq-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .jq-hero__spotify.jq-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .jq-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .jq-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .jq-hero__right.jq-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .jq-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .jq-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .jq-yt-thumb:hover img { opacity: 0.85; }
  .jq-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .jq-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .jq-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .jq-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .jq-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .jq-body.jq-visible { opacity: 1; transform: translateY(0); }
  .jq-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .jq-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .jq-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .jq-guest.jq-visible { opacity: 1; transform: translateY(0); }
  .jq-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .jq-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .jq-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .jq-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .jq-inner { padding-left: 32px; padding-right: 32px; }
    .jq-hero { padding-top: 32px; padding-bottom: 48px; }
    .jq-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .jq-hero__title { font-size: 24px; }
    .jq-hero__left { gap: 16px; }
    .jq-guest__title { font-size: 24px; margin-bottom: 24px; }
    .jq-guest__photo-bg { width: 260px; height: 300px; }
    .jq-guest__name { font-size: 24px; margin-top: 18px; }
    .jq-body__para { font-size: 14px; margin-bottom: 12px; }
    .jq-body { padding-bottom: 48px; }
    .jq-guest { padding-bottom: 48px; }
    .jq-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .jq-inner { padding-left: 16px; padding-right: 16px; }
    .jq-hero { padding-top: 51px; padding-bottom: 30px; }
    .jq-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .jq-hero__left { gap: 30px; }
    .jq-hero__title { font-size: 30px; }
    .jq-body__para { font-size: 16px; margin-bottom: 10px; }
    .jq-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left;}
    .jq-guest__photo-bg { width: 100%; height: 386px; }
    .jq-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .jq-body { padding-bottom: 30px; }
    .jq-guest { padding-bottom: 30px; }
    .jq-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("jq-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="jq-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 13 James Quinn"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="jq-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 13 James Quinn thumbnail" />
      <div className="jq-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="jq-hero">
      <div className="jq-inner">
        <div className="jq-hero__grid">
          <div className="jq-hero__left">
            <h1 ref={titleRef} className="jq-hero__title">
              EP 13 | A World Beyond Lithium | Faradian
            </h1>
            <div ref={spotifyRef} className="jq-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/3x3QsTEpiW9R8G4Me2yCgB?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 13 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="jq-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="jq-body">
      <div className="jq-inner">
        <p className="jq-body__para">
          In this episode, we discuss our world beyond the need to rely on Lithium. After the invention of the wheel, innovations in transportation barely evolved over 4,000 years. The arrival of the Internal Combustion Engine (or ICE technology) changed all of that during the late 1800s and it was the lead-acid battery that enabled the growth of the ICE mobility era, powering the electric starter and the other onboard systems for over 90 years. A competitor to the lead-acid emerged when commercially viable lithium batteries were launched in the mid 1908s. The age of Lithium arrived, powering our phones, personal portable electronic gadgets and even underpinning the electric renaissance that we are witnessing today.
        </p>
        <p className="jq-body__para">
          But there is a dark side to Lithium, the need to rape & pillage entire hillsides to power our mobility + communications using a finite source for an ever-hungry and growing human demand, is frankly not sustainable. If all of us on the planet move to electric mobility today there would just not be enough Lithium to power our hopes and prices would soar, resulting in all of us making choices to keep polluting and staying with ICE technology. Moreover, Lithium mining requires significant water resources and as of 2020, it takes 2 million litres of water to mine enough Lithium to power just 90 cars.
        </p>
        <p className="jq-body__para">
          Hydrogen is often thought of as a panacea to this problem as an FCEV uses one-tenth amount of Lithium for mobility. But there may be an exciting new development that has popped its head up over the horizon. It's a battery technology that's been going rounds over few years and now seems to finally be landed on a firm footing and could help save the future of our hopes and aspirations for a cleaner planet that is not built on the premise of humans pillaging scarce natural resources. This surprising technology could be Sodium-ion batteries.
        </p>
        <p className="jq-body__para">
          Faradion, a British company based in Sheffield in the United Kingdom is pioneering the next generation of advanced low-cost battery materials, implying sodium-ion technology which itself is extinguishable from leading other technologies for energy storage in terms of performance, but can be far cheaper than Lithium-ion batteries. We speak today with James Quinn, CEO of Faradion and a key global technology executive in this sector as well as an entrepreneur in both public and private companies.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="jq-guest">
      <div className="jq-inner">
        <h2 className="jq-guest__title">Our Guest</h2>
        <div>
          <div className="jq-guest__photo-bg">
            <img src={GuestImg} alt="James Quinn" />
          </div>
          <p className="jq-guest__name">James QUINN</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep13JamesQuinn() {
  return (
    <>
      <style>{CSS}</style>
      <div className="jq-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}